import { InfoItem } from "@/components/molecules";

export const FulfillmentContent = ({ fulfillmentData }) => {
  const getVal = (v) => v !== undefined && v !== null ? v : '-';

  return (
    <>
      {/*Transactions -> Fulfillment Details Section */}
      <div className="order-overview">
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          <InfoItem
            label="Fulfilled Quantity"
            value={getVal(fulfillmentData?.fulfilledQuantity)}
          />
          <InfoItem label="Tracking ID" value={getVal(fulfillmentData?.trackingId)} />
          <InfoItem
            label="Shipping Date"
            value={getVal(fulfillmentData?.shippingDate)}
          />
          <InfoItem
            label="Rejected Quantity"
            value={getVal(fulfillmentData?.rejectedQuantity)}
          />
        </div>
      </div>
    </>
  );
};
